var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58325 4.0426H19.5833V16.1259C19.5833 16.347 19.4955 16.5589 19.3392 16.7152C19.1829 16.8715 18.9709 16.9593 18.7499 16.9593H5.41659C5.19557 16.9593 4.98361 16.8715 4.82733 16.7152C4.67105 16.5589 4.58325 16.347 4.58325 16.1259V4.0426Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41659 0.292603H12.0833V4.45927H4.58325V1.12594C4.58325 0.904922 4.67105 0.69296 4.82733 0.53668C4.98361 0.3804 5.19557 0.292603 5.41659 0.292603Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 0.292603H18.7499C18.9709 0.292603 19.1829 0.3804 19.3392 0.53668C19.4955 0.69296 19.5833 0.904922 19.5833 1.12594V4.45927H12.0833V0.292603Z",
    fill: "#33C481"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 4.45923H4.58325V8.62589H12.0833V4.45923Z",
    fill: "#107C41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5833 4.45923H12.0833V8.62589H19.5833V4.45923Z",
    fill: "#21A366"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5833 8.62598H12.0833V12.7926H19.5833V8.62598Z",
    fill: "#107C41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.58325 4.87598H4.58325V14.0426H9.58325C9.80427 14.0426 10.0162 13.9548 10.1725 13.7986C10.3288 13.6423 10.4166 13.4303 10.4166 13.2093V5.70931C10.4166 5.4883 10.3288 5.27633 10.1725 5.12005C10.0162 4.96377 9.80427 4.87598 9.58325 4.87598Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74996 4.0426H1.24996C0.789722 4.0426 0.416626 4.4157 0.416626 4.87594V12.3759C0.416626 12.8362 0.789722 13.2093 1.24996 13.2093H8.74996C9.2102 13.2093 9.58329 12.8362 9.58329 12.3759V4.87594C9.58329 4.4157 9.2102 4.0426 8.74996 4.0426Z",
    fill: "#148349"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66499 5.86548H3.98458L5.05208 7.99215L6.20666 5.86548H7.42208L5.74666 8.61715L7.47416 11.3863H6.18041L4.99999 9.17298L3.82833 11.3863H2.52625L4.28833 8.61715L2.66499 5.86548Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.dc077e97b929fb14741626a8f0467ffb.svg";
export { ForwardRef as ReactComponent };